import React, { useState } from "react";
import { useIntl } from "react-intl";
import Button from "@ui-components/Button";

export const ReadMore = ({
  children,
  maxCharacterCount = 100,
  ...rest
}) => {
  const intl = useIntl();
  const shouldTruncate = children.length > maxCharacterCount;
  const [isTruncated, setIsTruncated] = useState(shouldTruncate);
  const resultString = isTruncated
    ? children.slice(0, maxCharacterCount) + "..."
    : children;
  function toggleIsTruncated(e) {
    e.preventDefault();
    setIsTruncated(!isTruncated);
  }

  return (
    <>
      <p>{resultString}</p>
      {shouldTruncate && (
        <div className="mt-2 mb-4 block">
          <Button
            textCls="text-xs"
            paddingCls="py-1 px-2"
            onClick={toggleIsTruncated}
            {...rest}
          >
            {isTruncated
              ? intl.formatMessage({ id: "read_more" })
              : intl.formatMessage({ id: "read_less" })}
          </Button>
        </div>
      )}
    </>
  );
};
